module.exports = __webpack_public_path__ + "media/images/lgt/gallery4-9160171fda2f2e33f67ce9b24bb74093.jpg";